import { Store, StoreServiceSite } from '../hooks/types'

export const mapSitesToStores = (stores: StoreServiceSite[]): Store[] =>
  stores.map((site) => {
    const addressAttr = site.attributes.find(
      (attr) => attr.attributeId === 'address',
    )
    const coordsAttr = site.attributes.find(
      (attr) => attr.attributeId === 'coordinates',
    )
    const displayNameAttr = site.attributes.find(
      (attr) => attr.attributeId === 'display_name',
    )

    // const edynamixAttr = site.attributes.some(
    //   (attr) => attr.attributeId === 'edynamix-integrated',
    // )

    const dealerIdAttr = site.attributes.find(
      (attr) => attr.attributeId === 'dealer-id',
    )

    const addressValue = addressAttr?.attributeValue as {
      addressLine1: string
      city: string
      county: string
      postcode: string
    }
    const coordsValue = coordsAttr?.attributeValue as {
      latitude: number
      longitude: number
    }

    return {
      id: site.siteId,
      name: displayNameAttr?.attributeValue as string,
      addressLine1: addressValue?.addressLine1 || '',
      town: addressValue.city,
      county: addressValue.county,
      postcode: addressValue.postcode,
      coordinates: coordsValue,
      //TODO: Switch to using edynamixAttr to turn on workshop+ booking
      // canBookAppointment: edynamixAttr,
      canBookAppointment: false,
      dealerId: (dealerIdAttr?.attributeValue as string) || '',
    }
  })
